// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"752c6e32","607":"0dc07056"}[chunkId] + ".chunk.css";
};